// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router/router'
import 'vuetify/dist/vuetify.min.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import {autoscroll} from "vue-autoscroll/src/vueAutoscroll";
import VueConfirmDialog from 'vue-confirm-dialog/src'
import Vuetify from 'vuetify'
import VueSocketIOExt from 'vue-socket.io-extended';
import { io } from 'socket.io-client';
Vue.prototype.$hostname = "https://dlivrd-payment-server.herokuapp.com"
//Vue.prototype.$hostname = "http://127.0.0.1:5000"
const socket = io(Vue.prototype.$hostname);
Vue.use(VueSocketIOExt, socket);


Vue.use(VueConfirmDialog)
Vue.component('vue-confirm-dialog', VueConfirmDialog.default)
Vue.use(autoscroll)
Vue.config.productionTip = false


Vue.use(Vuetify, {
  theme: {
    primary: '#1976d2',
    secondary: '#151720',
    accent: '#878787',
    error: '#b71c1c'
  }
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  vuetify : new Vuetify(),
  data: {
    drawer: true,
    selectedroute:""
  },
  sockets: {
    connect() {
      console.log('socket connected')
      console.log('event is been refisteded connected')
    }
  },
  render:h =>  h( App ),
})



// WEBPACK FOOTER //
// ./src/main.js